import React from "react";

const BannerOne = () => {
  return (
    <div>
    <h1>A leitura engrandece a alma.</h1>
    <h3>Voltaire</h3>
    </div>
  );
};

export default BannerOne;
